<template>
  <!-- ############ Route view For child pages-->
  <v-layout>
    <router-view />
  </v-layout>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { none } from '@/services/Helpers'
import { usePackingSlipStore } from '@/store/packingSlip'
import VLayout from '@/views/Layouts/DefaultLayout.vue'

export default defineComponent({
  name: 'Staff',
  components: {
    VLayout,
  },
  setup() {
    const packingSlipStore = usePackingSlipStore()

    onMounted(() => {
      packingSlipStore.setAssignmentType('consolidate')
      if (packingSlipStore.staffs.length === 0) {
        packingSlipStore.fetchStaffs().catch(none)
      }
    })

    return {}
  },
})
</script>
